import { render, staticRenderFns } from "./NewFormOfPaymentDialog.vue?vue&type=template&id=5efe13f4&scoped=true"
import script from "./NewFormOfPaymentDialog.vue?vue&type=script&lang=js"
export * from "./NewFormOfPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe13f4",
  null
  
)

export default component.exports